var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "control",
            "title": "솔루션",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" 스마트팜 제품 솔루션 ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    staticClass: "mb-0",
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v(" 측정 센서를 통해 식물공장내 구역별 상태와 작물의 근권부(뿌리 환경)를 모니터링하여 작물 생장에 필요한 적정량의 영양분과 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("관수제어 및 환경 제어가 가능합니다. 효율적인 식물공장 운영을 가능하게 하는 식물공장 통합관제 시스템입니다. ")];
      },
      proxy: true
    }])
  }, [_vm._v(" 식물공장의 다양한 재배환경을 모니터링하여 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 작물의 생육환경을 제어하는 "), _c('b', [_vm._v("식물공장 통합관제 시스템")])])], 1), _c('page-section', {
    staticClass: "d-flex align-center min-h-lg-980px"
  }, [_c('div', {
    staticClass: "page-section__bg",
    staticStyle: {
      "background-image": "url(/images/sub/solution/plant/control-bg.jpg)"
    }
  }), _c('v-img', {
    staticClass: "d-md-none mx-auto",
    attrs: {
      "max-width": "350",
      "aspect-ratio": 700 / 2596,
      "src": "/images/sub/solution/plant/control-img-mo.png",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  }), _c('v-img', {
    staticClass: "d-none d-md-block mx-auto",
    attrs: {
      "max-width": "1200",
      "aspect-ratio": 1200 / 216,
      "src": "/images/sub/solution/plant/control-img.png",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  })], 1), _c('page-section', {
    staticClass: "grey lighten-5"
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "rounded": "",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "d-flex pa-30px pa-md-40px pa-lg-80px"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "1000",
      "aspect-ratio": 1000 / 634,
      "src": "/images/sub/solution/plant/control-img2.png"
    }
  })], 1)]), _c('div', {
    staticClass: "pt-30px pt-md-40px pt-lg-80px"
  }, [_c('v-row', {
    staticClass: "ma-n20px ma-md-n30px"
  }, [_c('v-col', {
    staticClass: "pa-20px pa-md-30px",
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left",
      "data-aos-delay": "100"
    }
  }, [_c('tit-wrap-sprout', [_vm._v(" 식물공장 및 식물 근권부 및 환경 모니터링 ")]), _c('txt-item', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v("측정항목")];
      },
      proxy: true
    }])
  }, [_vm._v(" 온도, 습도, pH, EC, CO2, LED인공광 ")])], 1), _c('v-col', {
    staticClass: "pa-20px pa-md-30px",
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left",
      "data-aos-delay": "200"
    }
  }, [_c('tit-wrap-sprout', [_vm._v(" 식물공장 통합관제 제어 시스템 ")]), _c('txt-item', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v("제어항목")];
      },
      proxy: true
    }])
  }, [_vm._v(" 냉난방, 공조 환기, LED인공광, 칠러 및 관수, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("재배대 물수위 ")])], 1)], 1)], 1)], 1), _c('page-section', {
    staticClass: "page-section--last"
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "rounded": "",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 1200 / 770,
      "content-class": "d-flex align-center justify-center"
    }
  }, [_c('div', {
    staticClass: "pa-30px pa-md-40px px-lg-80px"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "770",
      "width": _vm.$vuetify.breakpoint.lgAndUp ? '770' : '',
      "aspect-ratio": 770 / 376,
      "src": "/images/sub/solution/plant/control-img3.png"
    }
  }), _c('div', {
    staticClass: "pt-30px pt-md-40px pt-lg-60px"
  }, [_c('tit-wrap-small', {
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v(" PC와 모바일로 작물의 생장 정보 모니터링과 환경 제어가 가능한 시스템입니다. ")];
      },
      proxy: true
    }])
  }, [_vm._v(" IoT 복합환경제어 시스템 ")])], 1)], 1)])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }